import { addLabelArray } from "helpers/addLabelArray";
import { usersTypes } from "redux/reducers/users/types";
import { api_get, api_put, api_post, api_delete, PROYECT } from "services/api";
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";
import { loginTypes } from "redux/reducers/login/loginTypes";

const {
  SET_USERS,
  NEW_USER,
  SELECT_USER,
  UNSELECT_USER,
  UPDATE_USER,
  REMOVE_USER,
  SET_CONFIG_PAGE_USERS_SECTION,
  SET_CONFIG_PAGE_SIZE_USERS_SECTION,
  SET_CONFIG_SORTED_USERS_SECTION,
  SET_CONFIG_FILTERED_USERS_SECTION,
  GET_USER_BY_STATIONS,
} = usersTypes;
const {UPDATE_LOGIN_INFO} = loginTypes
const mainUrl = `${process.env.REACT_APP_URL}${PROYECT}`;
const urlUsers = `${mainUrl}/users`;
const urlRules = `${mainUrl}/rules`;


export const getUsers = () => {
  return async (dispatch) => {
    try {
      dispatch(startRequestComp('loadingUsers'))
      const rules = await api_get(urlRules).then(resp => addLabelArray(resp, 'tag'))
      const usersGet = await api_get(urlUsers)
      const users = usersGet.map(user => {
        const rulesLabels = user.rules.map(rule => {
          const ruleLabel = rules.find(r => r.tag === rule)
          return ruleLabel.id
        })
        return { ...user, rules: rulesLabels }
      }
      )
      const payload = { users, rules }
      dispatch({ type: SET_USERS, payload })
      dispatch(stopRequestComp('loadingUsers'))
    } catch (error) {
      dispatch(stopRequestComp('loadingUsers'))
      dispatch(setSnackbar(error))
    }
  }
}

export const newUser = (body, onClose) => {
  return async (dispatch) => {
    dispatch(startRequestComp('loadingNewUser'))
    try {
      const user = await api_post(urlUsers, body)
     dispatch({
        type: NEW_USER,
        payload: user
      })
      dispatch(stopRequestComp('loadingNewUser'))
      dispatch(setSnackbar('Usuario creado', 'success'))
      onClose()
    } catch (error) {
      dispatch(stopRequestComp('loadingNewUser'))
      dispatch(setSnackbar(error))
    }
  }

}

export const deleteUser = (id, close) => {
  return async (dispatch) => {
    try {
      await api_delete(`${urlUsers}/${id}`)
      await dispatch(setSnackbar('Usuario eliminado', 'success'))
      dispatch({type: REMOVE_USER, payload: id})
      setTimeout(() => {
        close()  
      }, 500);
    } catch (error) {
      dispatch(setSnackbar(error))
    }
  }

}

export const resetUserPassword = (id, password, close) => {
  return async (dispatch) => {
    try {
      await api_put(`${urlUsers}/${id}/password`, { password })
      await dispatch(setSnackbar('Contraseña restablecida', 'success'))
      setTimeout(() => {
        close()  
      }, 500);
    } catch (error) {
      dispatch(setSnackbar(error))
    }
  }

}

export const selectUser = (user) => {
  return {
    type: SELECT_USER,
    payload: user
  }
}
export const unselectUser = () => {
  return {
    type: UNSELECT_USER,
  }
}

export const editUser = (id, body, nav,) => {
  return async (dispatch) => {
    dispatch(startRequestComp('loadingUserEdit'))
      await api_put(`${urlUsers}/${id}`, body).then(resp => {
        dispatch({
          type: UPDATE_USER,
          payload: resp
        })

        body.updateLogin && dispatch({
          type: UPDATE_LOGIN_INFO,
          payload: resp.config,
        })
        dispatch(setSnackbar('Usuario actualizado', 'success'))
        nav()
      }).catch(error => {
        dispatch(setSnackbar(error))
      })
      dispatch(stopRequestComp('loadingEditUser'))
  }
}

export const getUsersByStations = (rule, idStation) => {
  const url = `${urlUsers}/rules/${rule}/stations/${idStation}`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingUserEdit'))
    await api_get(url).then(resp => {
      dispatch({
        type: GET_USER_BY_STATIONS,
        payload: resp
      })
    }).catch(error => {
      dispatch(setSnackbar(error))
    })
    dispatch(stopRequestComp('loadingEditUser'))
  }
}


export const configFiltersUsers = (filter) => {
  return {
    type: SET_CONFIG_FILTERED_USERS_SECTION,
    payload: filter,
  };
}
export const configPageUsers = (page) => {
  return {
    type: SET_CONFIG_PAGE_USERS_SECTION,
    payload: page,
  };
}
export const configPageSizeUsers = (pageSize) => {
  return {
    type: SET_CONFIG_PAGE_SIZE_USERS_SECTION,
    payload: pageSize,
  };
}
export const configSortsUsers = (sorted) => {
  return {
    type: SET_CONFIG_SORTED_USERS_SECTION,
    payload: sorted,
  };
}